import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { EntityService } from './../../shared/services/entity.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { Textarea } from './../../models/editors/textarea.model';
import { Partner } from '../../models/partners/partners.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';

@Component({
  selector: 'swb-partner-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class PartnerDetailComponent extends FormDetailBase<Partner> implements OnInit {

  public entity = new Partner({});

  public get fieldsConfig(): Array<any> {

    return [
      new Textbox({
        key: 'title',
        label: 'Název',
        validators: atLeastOneLang,
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        isMultilang: true,
        label: 'Popisek',
        wysiwyg: 'partner-detail'
      }),
      new Contained({
        key: 'file_id',
        label: 'Obrázek',
        upload: true,
        entity: this.entity.file
      })
    ];
  }

  public url = 'partners';

  protected _redirect = 'contacts';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined' && this._route.snapshot.outlet !== 'modal-form') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
